import { Link } from "react-router-dom";

export default function Logo({ to = "/", testId = "brand-link", className = "" }) {
  return (
    <Link to={to} data-testid={testId} className={`inline-flex items-center ${className}`}>
      <img src="/wah-logo.png" alt="Wealth Accelerator Hub" className="h-10 sm:h-11 w-auto"/>
    </Link>
  );
}
